export const MAX_FILE_SIZE = 5242880;
export const MAX_UPLOAD_SIZE = 20971520;
export const AVATAR_SIZES = '224x224,168x168,112x112';
export const NODE_ENV = process.env.NODE_ENV;
export const MODE = {
    DEV: 'development',
    PROD: 'production'
};